import axios from "axios";
import { notify } from "./../utils/notify";

const defaultErrorMessages = {
  503: "Não foi possível esabelecer uma conexão com o servidor. Verifique sua internet e tente novamente.",
};

axios.interceptors.response.use(
  (response) => {
    if (
      response.status === 200 &&
      response.data.warnings &&
      Array.isArray(response.data.warnings)
    ) {
      response.data.warnings.map((e) => notify(e, true, "warning"));
    }

    return response;
  },
  (error) => {
    //Erro de conexão
    if (error.message && error.message === "Network Error") {
      notify(
        "Não foi possível esabelecer uma conexão com o servidor. Verifique sua internet e tente novamente."
      );
      return Promise.reject(error);
    }

    if (
      error.response &&
      error.response.data &&
      Array.isArray(error.response.data.errors)
    ) {
      if (
        error.response.data.errors[0] &&
        error.response.data.errors[0].message
      ) {
        notify(error.response.data.errors[0].message);
      } else {
        error.response.data.errors.map((e) => notify(e));
      }
    }

    if (
      error.data &&
      error.data.warnings &&
      Array.isArray(error.data.warnings)
    ) {
      error.data.warnings.map((e) => notify(e, true, "warning"));
    }

    if (error.data && error.data.errors && Array.isArray(error.data.errors)) {
      error.data.errors.map((e) => notify(e, true, "warning"));
    }

    if (
      error.response &&
      error.response.data &&
      Array.isArray(error.response.data)
    ) {
      for (const msg of error.response.data) {
        notify(msg, true);
      }
    }

    const expectedError =
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500;

    //isCancel verifica se a requisição foi cancelada pelo usuário
    if (!expectedError && !axios.isCancel(error)) {
      console.error("Logging the error: " + error);
      console.error(error.response.data);
    } else if (expectedError) {
      if (defaultErrorMessages[error.response.status]) {
        notify(defaultErrorMessages[error.response.status], true);
      } else if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "string"
      ) {
        notify(error.response.data, error.response.status !== 412);
      }
    }

    return Promise.reject(error);
  }
);

axios.defaults.baseURL = process.env.REACT_APP_API_PLUG;

axios.defaults.timeout = 300000;

function setHeaders(value = {}) {
  axios.defaults.headers.common["x-auth-token"] =
    process.env.REACT_APP_API_PLUG_TOKEN;

  axios.defaults.headers.common["token-cognito"] =
    value.tokenCognito || sessionStorage.tokenCognito || null;

  axios.defaults.headers.common["token-values-user"] =
    value.tokenValuesUser || sessionStorage.tokenValuesUser || null;

  axios.defaults.headers.common["email"] =
    value.Email || sessionStorage.Email || null;

  axios.defaults.headers.common["refreshToken"] =
    value.refreshToken || sessionStorage.refreshToken || null;
}

const config = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  baseURL: axios.defaults.baseURL,
  setHeaders,
};

export default config;
